import type { ProductUnitItem, RecommendedListHeader } from '@weberus/shared-types';
import { useAtomValue } from 'jotai';
import { useQuery } from '@tanstack/react-query';
import { searchFilterKeywordAtom } from '@/app/_shared/store/search-filter';
import { queries } from '@/app/_shared/queries';

/* 레저 SRP 레저 추천 조회 */
export const useRecommendedLeisure = () => {
  const keyword = useAtomValue(searchFilterKeywordAtom);

  const { data, isLoading } = useQuery({
    ...queries.list.getRecommendationLocalLeisure({
      keyword: keyword || '',
      recommendType: 'LOCAL_LEISURE_SRP_NO_RESULT',
    }),
    enabled: !!keyword,
  });

  const header = data?.items?.[0] as RecommendedListHeader;
  const items = (data?.items?.filter((item) => item.type !== 'RECOMMENDED_LIST_HEADER') || []) as ProductUnitItem[];

  return { header, items, isLoading };
};
